'use client'
import { RightArrow } from '@/shared/Icons'
import React, { ReactNode, useState } from 'react'

type AccordianTypes = {
	title: string | ReactNode
	children?: string | ReactNode
	isOpen?: boolean
	onOpen?: () => void
	className?: string
	extraData?: ReactNode
}

function Accordian({ title, children, isOpen, onOpen, extraData, className = '' }: AccordianTypes) {
	const [open, setOpen] = useState(false)
	const isActive = onOpen ? isOpen : open
	function handleOpen() {
		onOpen ? onOpen() : setOpen((prev) => !prev)
	}

	return (
		<div
			className={` md:mb-4 last:mb-0 ${className || ''} `}
			onClick={handleOpen}>
			<div className={`${className || ''} sm:text-2xl text-base font-medium  border-b border-tabBorder py-4 select-none cursor-pointer flex items-center justify-between z-10`}>
				{title}
				{extraData}
				<div className={`transition-all text-[#84AFDC] w-4 h-4 ${isActive ? '-rotate-90' : 'rotate-90'}`}>
					<RightArrow />
				</div>
			</div>
			{/* <div className={`${isActive ? '' : 'opacity-0'} border-b border-b-separator-light mx-6`}></div> */}
			<div
				onClick={(e) => e.stopPropagation()}
				className={
					isActive
						? 'transition-all rounded-b-2xl opacity-1 bg-transparent md:bg-transparent'
						: 'transition-all overflow-hidden h-0 max-h-0 z-0 animate-close'
				}>
				{children}
			</div>
		</div>
	)
}

export default Accordian
